// extracted by mini-css-extract-plugin
export default {"wrapperSmall":"ProjectRightsGrid_wrapperSmall__5fQAm"};